<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    class="bg-gray-200 py-4 px-6"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      New target
    </h3>
    <FormulateInput
      name="identifier"
      type="text"
      label="Identifier"
      placeholder="Identifier"
      validation="required"
    />
    <FormulateInput
      name="classification_name"
      type="text"
      label="Classification Name"
      placeholder="Classification Name"
    />
    <FormulateInput
      name="saint_header"
      @input="updateParsedHeaders"
      type="textarea"
      label="Saint Header"
      validation-name="Saint Header"
      placeholder="Paste your Saint Header here"
      validation="required"
    />
    <p v-if="parsedHeaders.length > 0" class="text-sm mb-4">
      <span class="block mb-2">Parsed fields:</span>
      <span
        class="inline-block font-mono mb-1 mr-1 p-2 bg-gray-300"
        v-for="header in parsedHeaders"
        :key="header"
      >
        {{ header }}
      </span>
    </p>

    <FormulateErrors />

    <base-button type="submit" :loading="sending">
      {{ edit ? 'Save' : 'Create' }}
    </base-button>
  </FormulateForm>
</template>

<script>
import { mapState } from 'vuex';

const parseSaintHeader = (text) => {
  const headers = text
    .split('\n')
    .filter((row) => !row.startsWith('##'))
    .join('')
    .split('\t')
    .filter(Boolean);
  return headers;
};

export default {
  props: {
    clientId: Number,
    target: Object,
  },
  data() {
    return {
      formName: `exportTarget${this.target ? this.target.id : ''}`,
      formValues: this.target
        ? {
            ...this.target,
            saint_header: this.target.saint_header.join('\t'),
          }
        : {},
      sending: false,
      parsedHeaders: this.target
        ? parseSaintHeader(this.target.saint_header.join('\t'))
        : [],
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
    }),
    edit() {
      return Boolean(this.target);
    },
  },
  methods: {
    updateParsedHeaders(text) {
      this.parsedHeaders = parseSaintHeader(text);
    },
    async submit(data) {
      try {
        this.sending = true;
        this.$formulate.resetValidation(this.formName);
        const target = {
          ...data,
          export_client: this.clientId,
          saint_header: this.parsedHeaders,
        };
        if (this.edit) {
          await this.$store.dispatch('company/exports/updateTarget', target);
        } else {
          await this.$store.dispatch('company/exports/addTarget', target);
        }
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
